import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CalendarEventTitleFormatter } from '@beego/ngx-calendar';
import { CalendarController } from '../calendar.controller';
import { CalendarMobileEventTitleFormatter } from './calendar.mobile.formatter';

@Component({
	selector: 'calendar-mobile-page',
	templateUrl: 'calendar.mobile.page.html',
	styleUrls: ['./calendar.mobile.page.scss'],
	providers: [
		{
			provide: CalendarEventTitleFormatter,
			useClass: CalendarMobileEventTitleFormatter,
		},
	],
})
export class CalendarMobilePage implements OnInit {
	constructor(
		public readonly controller: CalendarController,
		private readonly route: ActivatedRoute
	) {}

	public ngOnInit(): void {
		this.route.url.subscribe(() => {
			this.controller.handleCalendarPageEntry();
			this.controller.getDisplayCalendarEvents();
		});
	}
}
